"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ProductAreaSelector = _interopRequireDefault(require("./ProductAreaSelector"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _productAreas = require("@insided/shared/utils/productAreas");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _chip = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/chip"));

var _listGroup = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/list-group"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductAreasDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductAreasDropdown, _Component);

  var _super = _createSuper(ProductAreasDropdown);

  function ProductAreasDropdown() {
    var _this$props$selectedP, _this$props$selectedP2;

    var _this;

    (0, _classCallCheck2.default)(this, ProductAreasDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "searchInputRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedProductAreasIds: (_this$props$selectedP = (_this$props$selectedP2 = _this.props.selectedProductAreas) === null || _this$props$selectedP2 === void 0 ? void 0 : _this$props$selectedP2.map(function (pa) {
        return String(pa.id);
      })) !== null && _this$props$selectedP !== void 0 ? _this$props$selectedP : [],
      isOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectProductAreas", function () {
      var _this$searchInputRef$;

      var selectedProductAreasIds = _this.state.selectedProductAreasIds;
      var _this$props = _this.props,
          productAreasV2 = _this$props.productAreasV2,
          onUpdateProductAreas = _this$props.onUpdateProductAreas;
      var selectedProductAreas = (0, _productAreas.getSelectedProductAreas)(selectedProductAreasIds, (0, _productAreas.getNormalizedPAList)(productAreasV2));
      onUpdateProductAreas(selectedProductAreas);
      (_this$searchInputRef$ = _this.searchInputRef.current) === null || _this$searchInputRef$ === void 0 ? void 0 : _this$searchInputRef$.focus({
        preventScroll: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeSelectedItem", function (id) {
      _this.setState(function (prevState) {
        return {
          selectedProductAreasIds: prevState.selectedProductAreasIds.filter(function (selectedId) {
            return selectedId !== id;
          })
        };
      }, function () {
        return _this.onSelectProductAreas();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProductNameById", function (productAreas, id) {
      var productArea = productAreas.find(function (pa) {
        return pa.id === id;
      });
      return (0, _preact.h)("div", {
        key: productArea === null || productArea === void 0 ? void 0 : productArea.name,
        className: "product-area-selected-item"
      }, (0, _preact.h)("div", {
        className: "product-area_selected-item-name"
      }, productArea === null || productArea === void 0 ? void 0 : productArea.name), (0, _preact.h)("div", {
        className: "product-area_selected-remove-button",
        onClick: function onClick(e) {
          e.stopPropagation();

          _this.removeSelectedItem(id);
        },
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();

            _this.removeSelectedItem(id);
          }
        }
      }, (0, _preact.h)(_assets.default, {
        icon: "close",
        width: 16,
        height: 16,
        color: "currentColor"
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDropdownToggle", function () {
      _this.setState(function (_ref) {
        var isOpen = _ref.isOpen;
        return {
          isOpen: !isOpen
        };
      }, function () {
        return requestAnimationFrame(function () {
          var _this$searchInputRef$2;

          return (_this$searchInputRef$2 = _this.searchInputRef.current) === null || _this$searchInputRef$2 === void 0 ? void 0 : _this$searchInputRef$2.focus({
            preventScroll: true
          });
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelect", function (productId, checked) {
      var selectedProductAreasIds = _this.state.selectedProductAreasIds;
      var productAreasV2 = _this.props.productAreasV2;
      var productArea = productAreasV2 ? (0, _productAreas.findProductAreaById)((0, _productAreas.getNormalizedPAList)(productAreasV2), productId) : undefined;
      if (!productArea) return;
      var childrenIds = productArea !== null && productArea !== void 0 && productArea.isSection ? (0, _productAreas.getChildPAIds)(productArea.children) : [];
      var updatedSelectedIds = checked ? (0, _productAreas.addPAIdsToList)(selectedProductAreasIds, productArea, childrenIds) : (0, _productAreas.removePAIdsFromList)(selectedProductAreasIds, productArea, childrenIds);

      _this.setState({
        selectedProductAreasIds: updatedSelectedIds
      });

      _this.onSelectProductAreas();
    });
    return _this;
  }

  (0, _createClass2.default)(ProductAreasDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          productAreasV2 = _this$props2.productAreasV2,
          isTopicModeration = _this$props2.isTopicModeration,
          closeOnDropdownClick = _this$props2.closeOnDropdownClick,
          showLabel = _this$props2.showLabel,
          showPhrase = _this$props2.showPhrase,
          _this$props2$displayS = _this$props2.displaySelectedItemsBelow,
          displaySelectedItemsBelow = _this$props2$displayS === void 0 ? false : _this$props2$displayS;
      var _this$state = this.state,
          selectedProductAreasIds = _this$state.selectedProductAreasIds,
          isOpen = _this$state.isOpen;
      var normalizedProductAreas = (productAreasV2 === null || productAreasV2 === void 0 ? void 0 : productAreasV2.length) > 0 ? (0, _productAreas.getNormalizedPAList)(productAreasV2) : [];
      var flattenProductAreas = (0, _productAreas.flattenPAList)(normalizedProductAreas);
      return (0, _preact.h)("div", {
        className: "form-group"
      }, showLabel && (0, _preact.h)("label", {
        htmlFor: "product-area-selector"
      }, "Product Areas"), (0, _preact.h)(_ProductAreaSelector.default, {
        labelId: "product-area-selector",
        isSearchable: true,
        showBothCheckboxAndCollapse: true,
        productAreas: normalizedProductAreas,
        selectedProductAreas: selectedProductAreasIds,
        onMultiSelect: this.onSelect,
        searchInputRef: this.searchInputRef,
        trigger: (selectedProductAreasIds === null || selectedProductAreasIds === void 0 ? void 0 : selectedProductAreasIds.length) === 0 || displaySelectedItemsBelow ? (0, _preact.h)(_Button.default, {
          title: showPhrase ? (0, _preact.h)(_phrase.default, {
            p: "select.product.area"
          }) : 'Select product areas',
          endIcon: isOpen ? (0, _preact.h)(_ChevronUp.default, {
            width: 16,
            height: 16
          }) : (0, _preact.h)(_ChevronDown.default, {
            width: 16,
            height: 16
          }),
          onClick: this.onDropdownToggle,
          size: "medium",
          fullWidth: true,
          "data-qa": "select-product-area"
        }) : (0, _preact.h)("div", {
          className: "select-product-area ".concat(isTopicModeration ? 'noBgAndBorder' : ''),
          onClick: this.onDropdownToggle,
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              _this2.onDropdownToggle();
            }
          },
          role: "button",
          tabIndex: 0
        }, (0, _preact.h)("div", {
          className: "product-area-selector-wrapper"
        }, selectedProductAreasIds === null || selectedProductAreasIds === void 0 ? void 0 : selectedProductAreasIds.map(function (id) {
          return _this2.getProductNameById((0, _productAreas.flattenPAList)(normalizedProductAreas), id);
        })), (0, _preact.h)("div", {
          className: "product-area-selector-icon"
        }, isOpen ? (0, _preact.h)(_ChevronUp.default, {
          width: 16,
          height: 16
        }) : (0, _preact.h)(_ChevronDown.default, {
          width: 16,
          height: 16
        }))),
        triggerClass: "dropdown-selector-wrapper--control",
        closeOnDropdownClick: closeOnDropdownClick
      }), displaySelectedItemsBelow && (0, _preact.h)(_listGroup.default, {
        spacing: "4px"
      }, (selectedProductAreasIds !== null && selectedProductAreasIds !== void 0 ? selectedProductAreasIds : []).map(function (id) {
        var productArea = flattenProductAreas.find(function (pa) {
          return pa.id === id;
        });
        return (0, _preact.h)(_chip.default, {
          key: productArea === null || productArea === void 0 ? void 0 : productArea.name,
          variant: "squared",
          size: "small",
          endIcon: (0, _preact.h)(_assets.default, {
            icon: "close",
            width: 14,
            height: 14
          }),
          onClick: function onClick() {
            _this2.removeSelectedItem(id);
          }
        }, productArea === null || productArea === void 0 ? void 0 : productArea.name);
      })));
    }
  }]);
  return ProductAreasDropdown;
}(_preact.Component);

var _default = ProductAreasDropdown;
exports.default = _default;